exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nh2[data-v-b8f0cf50] { margin: 10px 0;\n}\n", ""]);

// exports
